import { css } from '@emotion/react'
import { memo } from 'react'

export const ExploreIcon = memo(() => (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		css={css`
			display: block;
		`}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.4165 22.1665C18.249 22.1665 22.1665 18.249 22.1665 13.4165C22.1665 8.58401 18.249 4.6665 13.4165 4.6665C8.58401 4.6665 4.6665 8.58401 4.6665 13.4165C4.6665 18.249 8.58401 22.1665 13.4165 22.1665Z"
			stroke="currentColor"
			strokeWidth="2.1"
		/>
		<path
			d="M24.5002 24.4998L19.8335 20.2998"
			stroke="currentColor"
			strokeWidth="2.1"
			strokeLinecap="round"
		/>
	</svg>
))
